import { connect } from 'react-redux'
import { bool, string } from 'prop-types'
import React from 'react'
import {
  buildFiltersClassName,
  determineFiltersIsOpen,
  getArchitectsOptions,
  getArupServicesOptions,
  getCountryOptions,
  getHallUsesOptions,
  getInOutdoorOptions,
  getProjectTypesOptions,
  getSeatCountOptions,
  getYearOptions,
} from '../../../selectors'
import ClearAll from './ClearAll'
import MultiSelectFilter from './MultiSelectFilter'
import SearchableFilter from './SearchableFilter'

const Filters = (props) => {
  if (!props.isOpen) {
    return null
  }
  return (
    <div className={props.filtersClassName}>
      <div className="inner">
        <MultiSelectFilter
          className="seat-count"
          esKey="seat_count"
          name="Seat count"
          options={props.seatCountOptions}
        />
        <MultiSelectFilter
          className="hall-uses"
          esKey="hall_uses"
          name="Venue uses"
          options={props.hallUsesOptions}
        />
        <MultiSelectFilter
          className="in-outdoor"
          esKey="in_outdoor"
          name="In/Outdoor"
          options={props.inOutdoorOptions}
        />
        <MultiSelectFilter
          className="arup-services"
          esKey="arup_services"
          name="Arup services"
          options={props.arupServicesOptions}
        />
        <MultiSelectFilter
          className="project-type"
          esKey="project_types"
          name="Project type"
          options={props.projectTypesOptions}
        />
        <SearchableFilter
          className="architect"
          esKey="architects"
          name="Architect"
          options={props.architectsOptions}
          placeholder="Search architects"
        />
        <SearchableFilter
          className="country"
          esKey="country"
          name="Country"
          options={props.countryOptions}
          placeholder="Search countries"
        />
        <MultiSelectFilter
          className="year"
          esKey="year"
          name="Year"
          options={props.yearOptions}
        />
        <ClearAll />
      </div>
    </div>
  )
}
Filters.propTypes = {
  filtersClassName: string.isRequired,
  isOpen: bool.isRequired,
}

const mapStateToProps = state => ({
  architectsOptions: getArchitectsOptions(state),
  arupServicesOptions: getArupServicesOptions(state),
  countryOptions: getCountryOptions(state),
  filtersClassName: buildFiltersClassName(state),
  hallUsesOptions: getHallUsesOptions(state),
  inOutdoorOptions: getInOutdoorOptions(state),
  isOpen: determineFiltersIsOpen(state),
  projectTypesOptions: getProjectTypesOptions(state),
  seatCountOptions: getSeatCountOptions(state),
  yearOptions: getYearOptions(state),
})

export default connect(mapStateToProps, {
})(Filters)
